import {z} from '@hono/zod-openapi';

import {identifiers} from './identifiers';
import {isWithinMaxReportSpan} from './isWithinMaxReportSpan';
import {MAX_REPORT_SPAN_DAYS} from './MAX_REPORT_SPAN_DAYS';

export const WarehouseMovementsQuerySchema = z
  .object({
    from: z.string().date(),
    to: z.string().date(),
    warehouse: identifiers,
    manufacturer: identifiers,
    supplier: identifiers,
  })
  .refine((value) => value.from <= value.to, {
    message: 'The end date must not precede the start date',
    path: ['to'],
  })
  .refine((value) => isWithinMaxReportSpan(value.from, value.to), {
    message: `The period must not span more than ${MAX_REPORT_SPAN_DAYS} days`,
    path: ['to'],
  })
  .openapi('WarehouseMovementsQuery');

export type WarehouseMovementsQuery = z.infer<typeof WarehouseMovementsQuerySchema>;
